// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","clickable":"UN3v23","clickable_link":"oeJO8G","AniFadeIn":"_2ihYgi","AniFadeOut":"O7XCul","AniRotate":"efOT0N","AniPlaceholderFadeOut":"sL6azx"};